export const logo =
  'https://res.cloudinary.com/nahov91/image/upload/v1612519728/Greenline/assets/Screenshot_2021-02-05_at_11.07.01.jpg'
